import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { CostCenterPriceImportModel } from 'src/app/models/imports/cost-center-price-import-model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';
import { CostCenterPriceModel } from './../../models/archive/cost-center-price.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';

@Injectable({
  providedIn: 'root'
})
export class CostCenterPriceService {

  constructor(private _httpClient: HttpClient) { }

  getCostCenterPriceById(costCenterId: number): Observable<CostCenterPriceModel> {
    return this._httpClient.get<CostCenterPriceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costCenterPrice.GetCostCenterPriceById}/${costCenterId}`);
  }

  createCostCenterPrice(costCenterContractModel: CostCenterPriceModel): Observable<CostCenterPriceModel> {
    return this._httpClient.post<CostCenterPriceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costCenterPrice.CreateCostCenterPrice}`,
      costCenterContractModel);
  }

  deleteCostCenterPrice(costCenterId: number): Observable<CostCenterPriceModel> {
    return this._httpClient.delete<CostCenterPriceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costCenterPrice.DeleteCostCenterPrice}/${costCenterId}`);
  }

  updateCostCenterPrice(costCenterContractModel: CostCenterPriceModel): Observable<CostCenterPriceModel> {
    return this._httpClient.put<CostCenterPriceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costCenterPrice.UpdateCostCenterPrice}`,
      costCenterContractModel);
  }

  getCostCenterPriceByKeys(costCenterId: number, conceptInvoicingId: number, articleId: number): Observable<CostCenterPriceModel> {
    return this._httpClient.get<CostCenterPriceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costCenterPrice.GetCostCenterPriceByKeys}/${costCenterId}/${conceptInvoicingId}/${articleId}`);
  }

  getBaseUnitValueByKeys(costCenterId: number, articleId: number, swInvoiceUnitM2: boolean): Observable<number> {
    return this._httpClient.get<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costCenterPrice.GetBaseUnitValueByKeys}/${costCenterId}/${articleId}/${swInvoiceUnitM2}`)
  }

  getSwFacturacionEspecial(): Observable<boolean> {
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costCenterPrice.GetSwFacturacionEspecial}`);
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.costCenterPrice.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  importCostCenterPrices(costCenterImports: Array<CostCenterPriceImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costCenterPrice.ImportCostCenterPrices}`,
      costCenterImports);
  }

  getAllCostCenterPricesWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costCenterPrice.GetAllCostCenterPricesWithPaginationAsync}`,
      filters, { params: params });
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costCenterPrice.GetColumnsForGeneralConsultationAsync}`);
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.costCenterPrice.ExportGeneralConsultation}`,
      filters, { params, responseType: 'blob', });
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.costCenterPrice.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  getCostCenterById(costCenterId: number): Observable<any> {
    const params = new HttpParams().set('costCenterId', costCenterId);
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costCenterPrice.GetCostCenterByIdAsync}`,
      { params: params }
    );
  }

  getAllConceptInvoicings(swFacturacionEspecial: boolean): Observable<any> {
    const params = new HttpParams().set('swFacturacionEspecial', swFacturacionEspecial)
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costCenterPrice.GetAllConceptInvoicingsAsync}`,
      { params: params }
    );
  }

  getAllUnits(): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costCenterPrice.GetAllUnitsAsync}`);
  }

  getArticlesForCostCenterPrice(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costCenterPrice.GetArticlesForCostCenterPriceAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForArticle(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costCenterPrice.GetColumnsForArticleAsync}`);
  }

  getAllCostCentersForSelectAsync(branchId: number, costCenterId: number): Observable<Array<any>> {
    const params = new HttpParams().set('branchId', branchId).set('costCenterId', costCenterId);
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costCenterPrice.GetAllCostCentersForSelect}`,
      { params: params });
  }
}
